import { PenTool, Smartphone, Search, Zap, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "../components/Reveal";

const SERVICES = [
  { icon: PenTool, title: "Custom Design", desc: "Tailored to your business, not a template" },
  { icon: Smartphone, title: "Mobile Optimised", desc: "Works perfectly on any device" },
  { icon: Search, title: "SEO Setup", desc: "Helps people find you on Google" },
  { icon: Zap, title: "Fast Turnaround", desc: "Live and ready quickly" },
];

export default function WhatWeDoPage() {
  const navigate = useNavigate();
  return (
    <div className="pt-28 md:pt-32 px-5 md:px-10 pb-10 md:pb-16">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">WHAT WE DO</p>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#F7FAFF] leading-tight">
                  Websites Built <span className="text-gradient">Around Your Business.</span>
                </h2>
                <p className="mt-6 text-base md:text-lg text-[#AEBFD8] leading-relaxed max-w-xl">
                  We combine thoughtful design with reliable engineering to create websites that look professional,
                  communicate clearly and help turn visitors into customers.
                </p>
                <button onClick={() => navigate("/pricing")} data-testid="explore-services-btn"
                  className="btn-secondary mt-8 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base font-semibold min-h-[44px]">
                  See Pricing <ArrowRight size={18} />
                </button>
              </div>

              <div className="grid sm:grid-cols-2 gap-5">
                {SERVICES.map((s, i) => (
                  <Reveal key={s.title} delay={i * 0.08}>
                    <div className="glass-card h-full px-5 py-6" data-testid="service-card">
                      <span className="grid place-items-center w-12 h-12 rounded-xl bg-[rgba(0,168,255,0.15)] border border-[rgba(65,176,255,0.4)] mb-4">
                        <s.icon size={22} className="text-[#39D5FF]" />
                      </span>
                      <h3 className="text-lg font-bold text-[#F7FAFF]">{s.title}</h3>
                      <p className="mt-2 text-sm text-[#AEBFD8] leading-relaxed">{s.desc}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
